"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StateStorage {
    getItem(key) {
        const item = window.localStorage.getItem(key);
        if (item !== null) {
            return JSON.parse(item);
        }
        return item;
    }
    storeItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    removeItem(key) {
        localStorage.removeItem(key);
    }
}
exports.default = StateStorage;
;
